import { CandleTooltipProps } from './types';

import cn from './CandleWorkersHeatmap.module.scss';

export const CandleTooltip = ({ title, candle_worker, candle_validation }: CandleTooltipProps) => {
  if (!candle_validation && !candle_worker) {
    return (
      <div className={cn.tooltip}>
        <div className={cn.information}>
          <p>No Data</p>
          <p>{title}</p>
        </div>
      </div>
    );
  }
  if (candle_validation) {
    return (
      <div className={cn.tooltip}>
        <div className={cn.information}>
          <p>Candles</p>
          <p>{candle_validation.since_date}</p>
        </div>
        <div className={cn.information}>
          <p>Minutes</p>
          <p>{candle_validation.minute_percent_formatted}</p>
        </div>
        <div className={cn.information}>
          <p>Hours</p>
          <p>{candle_validation.hour_percent_formatted}</p>
        </div>
        <div className={cn.information}>
          <p>Day</p>
          <p>{candle_validation.day_percent_formatted}</p>
        </div>
      </div>
    );
  }
  return (
    <div className={cn.tooltip}>
      <div className={cn.information}>
        <p>{candle_worker?.status_name}</p>
        <p>{title}</p>
      </div>
    </div>
  );
};
